<!--Preloader area start here-->
<div id="loader" class="loader orange-color">
  <div class="loader-container">
    <div class='loader-icon'>
      <img src="assets/images/pre-logo1.png" alt="PVKK PG & Degree College">
    </div>
  </div>
</div>
<!--Preloader area End here-->

<router-outlet></router-outlet>


<!-- Footer Start -->
<app-footer></app-footer>
<!-- Footer End -->
<!-- start scrollUp  -->
<div id="scrollUp" class="yellow-color">
  <i class="fa fa-angle-up"></i>
</div>
<!-- End scrollUp  -->
<!-- Search Modal Start -->
<div aria-hidden="true" class="modal fade search-modal" role="dialog" tabindex="-1">
  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    <span class="flaticon-cross"></span>
  </button>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="search-block clearfix">
        <form>
          <div class="form-group">
            <input class="form-control" placeholder="Search Here..." type="text">
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- Search Modal End -->
